import {
  TRANSFER_STATUS_COMPLETED,
  TRANSFER_STATUS_INPROGRESS,
  TRANSFER_STATUS_PENDING,
} from "manifest-bridge-core/src/transferStatus";

import { TransferStatusTypes } from "../class/transferDetails";
import { CloseParams } from "../typings";

const transformTransferStatus = (transferStatus: TransferStatusTypes): CloseParams["transferIntentStatus"] => {
  if (transferStatus === TransferStatusTypes.inProgress) {
    return TRANSFER_STATUS_INPROGRESS;
  }
  if (transferStatus === TransferStatusTypes.none) {
    return TRANSFER_STATUS_PENDING;
  }
  return TRANSFER_STATUS_COMPLETED;
};

export default transformTransferStatus;
